module.exports = __webpack_public_path__ + "media/images/flags/32/Lesotho-a601a8766480b76f76c74f0a1bb4b466.png";